module.exports = __webpack_public_path__ + "img/4.84f11513.jpg";